import { render, staticRenderFns } from "./MachineryPartsAddLayer.vue?vue&type=template&id=f071c480&scoped=true&"
import script from "./MachineryPartsAddLayer.vue?vue&type=script&lang=js&"
export * from "./MachineryPartsAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./MachineryPartsAddLayer.vue?vue&type=style&index=0&id=f071c480&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f071c480",
  null
  
)

export default component.exports